// project-imports
import {
    GET_QUICK_INSIGHTS_BEGIN,
    GET_QUICK_INSIGHTS_FAILURE,
    GET_QUICK_INSIGHTS_SUCCESS,
    UPSERT_QUICK_INSIGHTS_USER_INTERACTION_BEGIN,
    UPSERT_QUICK_INSIGHTS_USER_INTERACTION_SUCCESS,
    UPSERT_QUICK_INSIGHTS_USER_INTERACTION_FAILURE,
    GET_USER_INTERACTION_BY_INSIGHTS_BEGIN,
    GET_USER_INTERACTION_BY_INSIGHTS_SUCCESS,
    GET_USER_INTERACTION_BY_INSIGHTS_FAILURE,
    GET_ALL_INSIGHTS_USER_INTERACTION_BEGIN,
    GET_ALL_INSIGHTS_USER_INTERACTION_SUCCESS,
    GET_ALL_INSIGHTS_USER_INTERACTION_FAILURE,

} from "../constants/actions";

// State variable initialization
const initialState = {
    isLoading: false,
    isInteractionLoading: false,
    isError: null,
    quickInsights: [],
    insightsUserInteraction: [],
};

const quickInsightsReducer = (state = initialState, action) => {

    if (action.type === GET_QUICK_INSIGHTS_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            isError: null,
        };
    }
    if (action.type === GET_QUICK_INSIGHTS_SUCCESS) {
        // Update state with all blogs
        return {
            ...state,
            isLoading: false,
            quickInsights: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_QUICK_INSIGHTS_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            isError: action.payload,
        };
    }

    // Add User Interaction
    if (action.type === UPSERT_QUICK_INSIGHTS_USER_INTERACTION_BEGIN) {
        // Set loading state

        return {
            ...state,
            isInteractionLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === UPSERT_QUICK_INSIGHTS_USER_INTERACTION_SUCCESS) {
        // Update state with all data
        const payload = action?.payload;

        if (!payload) return state; // Guard clause if payload is missing

        let existingData = state?.insightsUserInteraction || [];
        const index = (state?.insightsUserInteraction || []).findIndex((i) => (i?.insightId === payload?.insightId && (i?.userId === payload?.userId)));

        let updatedData;
        if (payload && index !== -1) {
            // Replace the item by creating a new array
            updatedData = existingData?.map((item, i) => i === index ? payload : item);
        } else {
            // Append the item by creating a new array
            updatedData = [...existingData, payload];
        }

        return {
            ...state,
            isInteractionLoading: false,
            insightsUserInteraction: updatedData,
            isError: null,
        };
    }

    if (action.type === UPSERT_QUICK_INSIGHTS_USER_INTERACTION_FAILURE) {
        // Set error state
        return {
            ...state,
            isInteractionLoading: false,
            isError: action.payload,
        };
    }

    // Get user 
    if (action.type === GET_USER_INTERACTION_BY_INSIGHTS_BEGIN) {
        // Set loading state
        return {
            ...state,
            isInteractionLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_USER_INTERACTION_BY_INSIGHTS_SUCCESS) {
        // Update state with all data
        return {
            ...state,
            isInteractionLoading: false,
            insightsUserInteraction: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_USER_INTERACTION_BY_INSIGHTS_FAILURE) {
        // Set error state
        return {
            ...state,
            isInteractionLoading: false,
            isError: action.payload,
        };
    }


    if (action.type === GET_ALL_INSIGHTS_USER_INTERACTION_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            isError: null,
        };
    }
    if (action.type === GET_ALL_INSIGHTS_USER_INTERACTION_SUCCESS) {
        // Update state with all blogs
        return {
            ...state,
            isLoading: false,
            insightsUserInteraction: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_ALL_INSIGHTS_USER_INTERACTION_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            isError: action.payload,
        };
    }

    return state;
};

export default quickInsightsReducer;
